import React, { useState, useEffect } from 'react';
import Popup from '../../UI/Popup/Popup';
import LabelPopupContent from '../../UI/Popup/LabelPopupContent';
import './Labels.scss';


const LabelHref = (props) => {
    const {children, label, href, onLabelClick} = props;

    function goToUrl(url, event) {
        event.preventDefault()
        window.open(url, '_blank');

        return;
    }


    if (href) {
        return (
            <a target='_blank' onClick={(e) => goToUrl(href, e)}>{children}</a>
        )
    }

    return (
        <div onClick={onLabelClick}>
            {children}
        </div>
    )
}

const Labels = ({
    type,
    slot,
    product = {},
    children,
    attributeCodePrefix,
    excludeAttributeCodePrefix,
}) => {
    const {emlabels, attachments, lifetime_status} = product;
    const productLabels = Array.isArray(emlabels) ? emlabels : [];
    const energyLabelAttachment = Array.isArray(attachments)
        ? attachments.find(attachment => attachment.label === 'energy_label')
        : null;
    const energyLabelHref = energyLabelAttachment?.link || energyLabelAttachment?.frontend_url;
    const [isMobile, setIsMobile] = useState(false);
    const [popupLabel, setPopupLabel] = useState(null);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.matchMedia('(max-width: 767px)').matches);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const labels = productLabels.filter((label) => {
        const position = label[[type, 'position'].join('_')];
        const attributeCode = label.attribute_code || '';
        const matchesAttribute = !attributeCodePrefix || attributeCode.startsWith(attributeCodePrefix);
        const isExcluded = excludeAttributeCodePrefix && attributeCode.startsWith(excludeAttributeCodePrefix);
        return position == slot && matchesAttribute && !isExcluded;
    });

    function getStyle(label) {
        let style = {};
        if (label.label_image) {
            style['backgroundImage'] = 'url(' + label.label_image + ')'
        }
        return style;
    }

    const handleLabelClick = (label) => {
        if (isMobile && label.label_text) {
            setPopupLabel(label);
        }
    };

    const closePopup = () => {
        setPopupLabel(null);
    };

    return (
        <>
            <ul className={['labels', slot, type].join(' ')}>
                {
                    labels.map((label, index) => {
                            const href = label.href || (
                                label.attribute_code?.startsWith('energetski_razred')
                                    ? energyLabelHref
                                    : null
                            );

                            return (
                                <li key={index} data-tooltip={isMobile ? null : label.label_text}>
                                    <LabelHref
                                        label={label}
                                        href={href}
                                        onLabelClick={() => handleLabelClick(label)}
                                    >
                                        {/*{label.label_text && <span className='label'>{label.label_text}</span>}*/}
                                        <div style={getStyle(label)} />
                                    </LabelHref>
                                </li>
                            )
                        }
                    )
                }
                {children}
            </ul>
            <Popup isOpen={!!popupLabel} onClose={closePopup} title={null}>
                <LabelPopupContent
                    image={popupLabel?.label_image}
                    title={popupLabel?.label_text}
                    description={popupLabel?.description}
                />
            </Popup>
        </>
    )
}

export default Labels;
